// Footer.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";

const Footer = () => {
  const [contactInfo, setContactInfo] = useState({
    email: [],
    phone: [],
    location: "",
    address: "",
    logo: "",
    summery: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/contact/contact`
        );
        const data = await response.json();

        // Parse email and phone from JSON strings if needed
        const emailArray = Array.isArray(data?.email)
          ? data.email
          : typeof data?.email === "string"
          ? JSON.parse(data.email || "[]")
          : [];

        const phoneArray = Array.isArray(data?.phone)
          ? data.phone
          : typeof data?.phone === "string"
          ? JSON.parse(data.phone || "[]")
          : [];

        setContactInfo({
          email: emailArray,
          phone: phoneArray,
          location: data?.location || "",
          address: data?.address || "",
          logo: data?.logo || "",
          facebook_link: data?.facebook_link,
          x_link: data?.x_link,
          instagram_link: data?.instagram_link,
          linkedin_link: data?.linkedin_link,

          summery:
            data?.summery ||
            "Empowering financial transparency and community development through innovative governance solutions.",
        });
      } catch (err) {
        console.error("Error fetching contact data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchContactInfo();
  }, []);

  const links = [
    {
      title: "Office",
      items: [
        { name: "About Us", path: "/about" },
        { name: "Services", path: "/services" },
        { name: "CSOs", path: "/#" },
        { name: "News", path: "/news" },
      ],
    },
    {
      title: "Support",
      items: [
        { name: "FAQ", path: "/services" },
        { name: "Privacy Policy", path: "/#" },
        { name: "Terms", path: "/#" },
        { name: "Contact", path: "/contact" },
      ],
    },
  ];
  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3">
              {contactInfo.logo && (
                <img
                  src={`${process.env.REACT_APP_API_URL}/${contactInfo.logo}`}
                  alt="Logo"
                  className="w-10 h-10 rounded-lg shadow-lg object-contain"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              )}
              <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                <p className='text-xl font-serif font-bold'>Bishoftu City Administration Finance Office</p>              </span>
            </Link>
            <p
              className="text-gray-600 dark:text-gray-400 text-sm"
              dangerouslySetInnerHTML={{
                __html:
                  contactInfo.summery ||
                  "Empowering financial transparency and community development through innovative governance solutions.",
              }}
            ></p>
          </div>

          {links.map((section) => (
            <div key={section.title} className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                {section.title}
              </h3>
              <div className="space-y-2">
                {section.items.map((item) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    className="block text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
          ))}

          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
              Contact
            </h3>
            <div className="space-y-3 text-sm">
              {(contactInfo.location || contactInfo.address) && (
                <div className="flex items-start space-x-3">
                  <FaMapMarkerAlt className="w-5 h-5 text-gray-500 dark:text-gray-400 mt-1" />
                  <span className="text-gray-600 dark:text-gray-400">
                    {contactInfo.location || "Bishoftu, Oromia, Ethiopia"}
                    {contactInfo.address && (
                      <div className="mt-1">{contactInfo.address}</div>
                    )}
                  </span>
                </div>
              )}

              {contactInfo.email.length > 0 ? (
                <div className="flex items-start space-x-3">
                  <FaEnvelope className="w-5 h-5 text-gray-500 dark:text-gray-400 mt-1" />
                  <div>
                    {contactInfo.email.map((email, index) => (
                      <a
                        key={index}
                        href={`mailto:${email}`}
                        className="block text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400"
                      >
                        {email}
                      </a>
                    ))}
                  </div>
                </div>
              ) : null}

              {contactInfo.phone.length > 0 ? (
                <div className="flex items-start space-x-3">
                  <FaPhoneAlt className="w-5 h-5 text-gray-500 dark:text-gray-400 mt-1" />
                  <div>
                    {contactInfo.phone.map((phone, index) => (
                      <a
                        key={index}
                        href={`tel:${phone.replace(/\D/g, "")}`}
                        className="block text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400"
                      >
                        {phone}
                      </a>
                    ))}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="flex space-x-4 pt-4">
              <a
                href={
                  contactInfo.facebook_link
                    ? `https://www.facebook.com/${contactInfo.facebook_link}`
                    : "#"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700 transition-colors"
              >
                <FaFacebook className="w-5 h-5 text-gray-600 dark:text-gray-400" />
              </a>

              <a
                href={
                  contactInfo.x_link
                    ? `https://www.x.com/${contactInfo.x_link}`
                    : "#"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700 transition-colors"
              >
                <FaTwitter className="w-5 h-5 text-gray-600 dark:text-gray-400" />
              </a>

              <a
                href={
                  contactInfo.instagram_link
                    ? `https://www.instagram.com/${contactInfo.instagram_link}`
                    : "#"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700 transition-colors"
              >
                <FaInstagram className="w-5 h-5 text-gray-600 dark:text-gray-400" />
              </a>

              <a
                href={
                  contactInfo.linkedin_link
                    ? `https://www.linkedin.com/in/${contactInfo.linkedin_link}`
                    : "#"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700 transition-colors"
              >
                <FaLinkedin className="w-5 h-5 text-gray-600 dark:text-gray-400" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            © {new Date().getFullYear()} Bishoftu Finance Office. All rights
            reserved.
            <br />
            Developed by{" "}
            <a
              // href="https://dagmawiamare.netlify.app"
              href="#"
              className="text-blue-600 dark:text-blue-400 hover:underline"
            >
              korean international organization (KVO)
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
